// 1. Agregamos useEffect a la importación
import { useEffect } from "react";
import { Container } from "@mui/material";

import InsuranceHeader from "../components/InsuranceHeader";
import InsuranceData from "../components/InsuranceData";
import InsurenceButtons from "../components/InsuranceButtons";

// 2. Importamos la función de la nueva taxonomía
import { trackEventStep4View } from "../../../utils/analytics";

const InsuranceForm = () => {

  // 3. Lo metemos en un useEffect con [] para que solo dispare 1 vez
  useEffect(() => {
    trackEventStep4View().catch(e => console.warn("Error en analítica (Vista Step 4):", e));
  }, []);
 
  return (
    <Container
        maxWidth="md"
        disableGutters={{
            xs: true,
            md: false
        }}
        sx={{
            py: 2,
            px: 2
        }}>
      <InsuranceHeader />
      <InsuranceData />
      <InsurenceButtons />
    </Container>
  );
};

export default InsuranceForm;
